// Referral attribution utilities.
// Captures ?ref=code from any URL and persists to localStorage (7 days).
import axios from "axios";

const KEY = "trio_referrer";
const TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export function captureReferralFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("ref");
    if (code) {
      setReferral(code);
    }
  } catch (_) {
    /* noop */
  }
}

export function setReferral(code) {
  if (!code) return;
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ code, ts: Date.now() })
    );
  } catch (_) {
    /* noop */
  }
}

export function getReferralCode() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.code) return null;
    if (Date.now() - (parsed.ts || 0) > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed.code;
  } catch (_) {
    return null;
  }
}

export function clearReferral() {
  try {
    localStorage.removeItem(KEY);
  } catch (_) {
    /* noop */
  }
}

// Optional: validate the code against the backend so we can show "Referred by X"
export async function resolveReferral(apiBase, code) {
  if (!code) return null;
  try {
    const { data } = await axios.get(`${apiBase}/referral/${encodeURIComponent(code)}`);
    return data;
  } catch (_) {
    return null;
  }
}
